._helpChatbotEntry_10403_1 {
  display: flex;
  height: 100%; }

._helpWidgetSdkLoader_10403_5 {
  display: none; }
